import { DataSettings } from "../../../charts/models/data-settings.model";

export const posOrdersPerDayChartDataSettings: DataSettings[] = [
  new DataSettings("orders", "orders", "shared.orders", "#d0021b"),
];
